import React from "react";
import Headline from "./Headline";
import { notification } from "antd";
import Postcards from "../../components/shared/Postcards";
import HomeLink from "../../widgets/HomeLink";
import PostsApi from "../../api-services/posts-api.service";
import { useParams } from "react-router-dom";
import PaginationWidget from "../../widgets/PaginationWidget";

const LIMIT = 30;
const _posts = {
  "world": {
    type: "gcruise", 
    title: "GD World Cruises",
    logo: "gd_world-cruises_logo.png",
    banner: "gdcruise_cover.png"
  },
  "fly": {
    type: "fly_cruise", 
    title: "GD Fly Cruises",
    logo: "gd_fly-cruises_logo.png",
    banner: "gdcruise_cover.png"
  },
  "domestic": {
    type: "gd_domestic",
    title: "GD Domestic",
    logo: "gd-logo_round.png",
    banner: "gd_domestic.png"
  },
  "flight": {
    type: "flight", 
    title: "",
    breadcrumb: "GD Flight",
    logo: "gd_flight_icon.png",
    banner: "gd_flight_cover_latest.png"
  },
  "trip": {
    type: "gtrip",
    title: "",
    breadcrumb: "G-Trip",
    logo: "gtrip_logo.png",
    banner: "gtrip.png",
  }
}

function withParams(Component) {
  return props => <Component {...props} params={useParams()}/>;
}


class PostsPage extends React.Component <{params}>  {
  api = new PostsApi;

  state = {
    posts: [],
    total: 0,
    breadcrumbs: [],
    header:  null,
    banner: "",
    key: this.props.params['type'],
    currentPage: 1
  }

  componentDidMount() {
    this.getPosts(this.state.key);
  }

  componentDidUpdate(prevProps: Readonly<{ params: any; }>, prevState: Readonly<{}>, snapshot?: any): void {    
    const type = this.props.params['type'];
    if(prevProps.params.type != type){
      this.getPosts(type);
    }
  }

  getPosts(key, page=1){
    const postByKey = _posts[key];
    if(postByKey){
      this.api.getPosts(postByKey.type, page, {limit: LIMIT})
        .then(({posts, total}) => {
          const postsData = posts.map(post => {
            return {
              id: post.id,
              cover: post.thumbnail,
              name: post.title
            }
          })

          const title = postByKey.title;
          const breadcrumbs = [
            { title: <HomeLink/>},
            { title: title || postByKey.breadcrumb},
          ];

          const header = <>
                          <img src={`/iceholidays-assets/images/${postByKey.logo}`} alt={title} />
                          {title}
                        </>
          this.setState({posts: postsData, total, key, breadcrumbs, header, banner: postByKey.banner, currentPage: page})
        })
        .catch(error => {
          notification.error({ message: `An error occured while loading ${postByKey.title}.`});
        });
    }
  }

  handlePageChange = (page) => {
    this.getPosts(this.state.key, page);
  }


  render(){
    const {posts, key, breadcrumbs, header, banner} = this.state;
    return (
      <div id="gd-posts" className="gd-series-tour-page">
        <Headline showSearch={false} bannerImage={`/iceholidays-assets/images/${banner}`} breadcrumbs={breadcrumbs}>
          <span className="title">
            {header}
          </span>
        </Headline>

        <div className="gd-series-tour-page_body">
          {
            key == "trip" && <>
              <picture className="ad">
                <source media="(min-width: 769px)" srcSet="/iceholidays-assets/images/gtrip-ad.png" />
                <source media="(max-width: 768px)" srcSet="/iceholidays-assets/images/gtrip-ad-mobile.png" />
                <img src="/iceholidays-assets/images/gtrip-ad.png" alt="G-Trip Ad" />
              </picture>
              <hr/>
            </>
          }

          <Postcards items={posts} link={`posts/${key}/`}/>

          {this.state.total > 0 && <PaginationWidget totalItems={this.state.total} current={this.state.currentPage} maxItemsPerPage={LIMIT} pageChange={this.handlePageChange}/>}
        </div>

      </div>
    )
  }
}

export default withParams(PostsPage);